import React, { useRef } from "react";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";

import Icon from "app/Icon";
import _ from "app/lang";

import { ActionProps } from "../Action";
import ActionButton from "../ActionButton";
import ActionMenu from "../ActionMenu";

interface Props extends ActionProps {
    onCloudClick: () => any;
    onUserClick: () => any;
}

export default function ActionBar(props: Props) {
    const {
        name,
        open,
        tooltip,
        iconId,
        dropdownText,
        dropdownIcon,
        dropdown,
        onClick,
        onClose,
        onCloudClick,
        onUserClick
    } = props;

    const buttonElement = useRef<HTMLButtonElement>(null);

    const handleClick = () => onClick(name);
    const handleClose = () => onClose(name);

    return (
        <>
            <ActionButton onClick={handleClick}
                tooltip={tooltip}
                iconId={iconId}
                dropdownText={dropdownText}
                dropdownIcon={dropdownIcon}
                active={open}
                dropdown={dropdown}
                buttonRef={buttonElement}
                dotBadge={true}
                trackingId={props.trackingId}
            />

            <ActionMenu open={open}
                anchorEl={buttonElement.current}
                onClose={handleClose}
            >
                <MenuItem onClick={onCloudClick}>
                    <ListItemIcon>
                        <Icon small id="cloud" />
                    </ListItemIcon>
                    <ListItemText primary={_("Cloud")} />
                </MenuItem>
                <MenuItem onClick={onUserClick}>
                    <ListItemIcon>
                        <Icon small id="account_circle" />
                    </ListItemIcon>
                    <ListItemText primary={_("User")} />
                </MenuItem>
            </ActionMenu>
        </>
    );
}
